module.exports = __webpack_public_path__ + "static/media/icon-right_chevron.dff293cb.svg";